import { Component, OnInit, Input } from '@angular/core';
import { LogoutService } from '../../../services/logout/logout.service';
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input('showLogout') showLogout?: boolean;
  @Input('registration') registration?: boolean;
  descripcionUsuario: string = "";
  isMobile: boolean = false;

  constructor(
    private logoutService: LogoutService,
    private mobileDetectorService: MobileDetectorService 
  ) { }

  ngOnInit(): void {
    if(this.showLogout == undefined) {
      this.showLogout = true;
    }
    this.isMobile = this.mobileDetectorService.isMobile();
    this.descripcionUsuario =  localStorage.getItem("descripcionUsuario");
  }

  logout() {
    this.logoutService.logOut();
  }

}
